
<ng-template #headerRow let-isMenu="isMenu", let-hide="hide" >
  <div class="header-row"  [ngClass]="{hide: hide, 'menu-row': isMenu}">
    <ng-container *ngIf="!isMenu" [ngTemplateOutlet]="headers"></ng-container>
  </div>
</ng-template>

<ng-template #headers>
  <div class="header" *ngIf="!readOnly"></div>
  <div class="header" *ngIf="showDelete && !readOnly"></div>
  <ng-container *ngFor="let column of columns | filterOutHidden:hiddenColumns; last as last">
    <div [class]="'header ' + column.id" 
      [ngClass]="{ highlighted: column.highlighted, last: last }">
      <span *ngIf="!column?.hide" [innerHTML]="helpers.strWithBreak(column?.title)" ></span>
      <icon *ngIf="!!column.uneditable && !readOnly" [icon]="'locked'" [i12]="true"></icon>
    </div>
  </ng-container>
</ng-template>

<div class="grid" [ngStyle]="{'grid-template-columns': gridTemplateColumns }" [ngClass]="{ fullWidth: fullWidth }">
  <ng-container [ngTemplateOutlet]="headerRow" [ngTemplateOutletContext]="{isMenu: false, hide: false}"></ng-container>
  <div class="header-row with-message" *ngIf="!!message">
    <div class="menu message" [innerHTML]="helpers.strWithBreak(message)"></div>
  </div>
  <div class="nested-table-row empty" *ngIf="!!emptyMessage && !rows?.length">
    {{ emptyMessage }}
  </div>
  <ng-container *ngFor="let row of rows; first as firstRow; trackBy: trackByRow; index as r; last as last; first as first">
    <div class="row">
      <up-down-arrows *ngIf="!readOnly" [hideUp]="first" [hideDown]="last" (moveUp)="moveUp(r)" (moveDown)="moveDown(r)"></up-down-arrows>
      <delete-button *ngIf="showDelete && !readOnly" [deleteTitle]="deleteTitle" [deleteText]="deleteText" (delete)="deleteRow(r)"></delete-button>
      <ng-container *ngFor="let column of columns | filterOutHidden:hiddenColumns; first as firstCol; last as lastCol; trackBy: trackByColumn; index as c">
        <div *ngIf="{ data: row[column.id] } as vars" [class]="'cell body ' + column.id"
          [ngClass]="{ highlighted: column.highlighted, last: lastCol, lastRow: last }">
          <div class="inner-cell" [ngClass]="column.templateId" [ngStyle]="{ minWidth: column.minWidth || 'unset' }">
            <ng-container
              *ngIf="!!vars.data"
              [ngTemplateOutlet]="this[column.templateId]" 
              [ngTemplateOutletContext]="{ row: row, data: vars.data, column: column}">
            </ng-container>
            <div *ngIf="!vars.data">{{ column.noReadOnlyPlaceholder ? '' : '-' }}</div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>

<!-- Cell Templates -->
<ng-template #gridDateSelect let-row="row", let-data="data", let-column="column">
  <date-picker *ngIf="!readOnly" (onDateChange)="saveCell.emit({ saveData: $event, column: column, row: row })" [pickedDate]="data.date"></date-picker>
  <div *ngIf="readOnly" class="date">{{ data.date ? (data.date | date:'EEEE d MMMM y') : '-'}}</div>
</ng-template>

<ng-template #gridText let-row="row", let-data="data", let-column="column">
  <joi-input 
    [(model)]="data.text" 
    [placeholder]="readOnly ? '-' : column.placeholder" 
    (joiChange)="saveCell.emit({ saveData: null, column: column, row: row })"
    [disabled]="readOnly"
    [type]="'textarea'" 
    [autoSelect]="false" 
    [returnable]="true"
  ></joi-input>
</ng-template>

<ng-template #gridToggle let-row="row", let-data="data", let-column="column">
  <toggle-tab [readOnly]="readOnly" [borderless]="true" [toggled]="data.toggled" (toggle)="saveCell.emit({ saveData: null, column: column, row: row })" [addSpacer]="true"></toggle-tab>
</ng-template>
    
<ng-template #gridDropdown let-row="row", let-data="data", let-column="column">
  <div class="text" *ngIf="readOnly">{{ data.dropdownOption.title }}</div>
  <dropdown *ngIf="!readOnly"
    [selections]="column.dropdownOptions"
    [selected]="data.dropdownOption"
    [null_text]="'Status'"
    (select)="saveCell.emit({ saveData: $event, column: column, row: row })"
  ><div class="header">Select</div></dropdown>
</ng-template>

<ng-template #gridItem let-row="row", let-data="data", let-column="column">
  <icon class="locked-item" *ngIf="!!data.isItem && !readOnly" [icon]="'locked'" [i12]="true"></icon>
  <joi-input 
    [(model)]="data.text" 
    [placeholder]="readOnly ? '-' : column.placeholder" 
    (joiChange)="saveCell.emit({ saveData: null, column: column, row: row })"
    [disabled]="readOnly || column.uneditable"
    [type]="'textarea'" 
    [dropdownOptions]="!readOnly ? dropdownItems : null"
    (chooseDropdown)="chooseDropdown.emit($event)"
    [autoSelect]="false" 
    [returnable]="true"
  ></joi-input>
  <icon *ngIf="!readOnly && canAddItems"  class="item-select" (click)="addItem.emit({ event: $event, row: row })" matIcon="arrow_drop_down" [i18]="true"></icon>

</ng-template>

<ng-template #gridNumber let-row="row", let-data="data", let-column="column">
  <joi-input 
    [(model)]="data.amount" 
    [fixedWidth]="true"
    [placeholder]="readOnly ? '-' : column.placeholder"
    [allowableCharacters]="'0123456789.'" 
    [disabled]="readOnly || column.uneditable"
    (joiChange)="updateNumber(row, column)"
  ></joi-input>
</ng-template>

<ng-template #gridButton let-row="row", let-data="data", let-column="column">
  <small-button (click)="saveCell.emit({ saveData: null, column: column, row: row })">{{ data }}</small-button>
</ng-template>

<ng-template #gridMoney let-row="row", let-data="data", let-column="column">
  <icon *ngIf="data.locked" class="locked-money" [icon]="'locked'" [i12]="true"></icon>
  <joi-input 
    [ngClass]="{ inRed: data.inRed }"
    [(model)]="data.amount" 
    [fixedWidth]="true"
    [placeholder]="readOnly || data.locked || column.uneditable ? '-' : column.placeholder"
    [displayValue]="data.amount ? (data.amount | prettyNumbers) : null"
    [allowableCharacters]="'0123456789.'"
    [disabled]="readOnly || column.uneditable || data.locked"
    (joiChange)="updateNumber(row, column)"
  ></joi-input>
  <div class="percent" *ngIf="!!data.showPercent && !!data.amount">%</div>
</ng-template>

<ng-template #gridStatus let-row="row", let-data="data", let-column="column">
  <div class="text" *ngIf="readOnly">{{ data.status }}</div>
  <traffic-light-dropdown *ngIf="!readOnly"
    [colorObject]="gridStatusColors"
    [selections]="column.statusOptions"
    [selected]="data.status"
    [readOnly]="readOnly"
    (select)="saveCell.emit({ saveData: $event, column: column, row: row })"
  ></traffic-light-dropdown>
</ng-template>